import get from 'lodash.get'

export default function renderTemplate(text?: string, userData: { [key: string]: unknown } = {}) {
  const res = text?.replace(/\{\{([^}]+)\}\}/g, (_: string, expr: string) => {
    const [...vars] = expr.split('||').map((s: string) => s.trim())
    const results = vars.map((v) => get(userData, v, ''))
    const result = results.find((r) => r !== null && r !== undefined && r !== '')

    if (typeof result === 'string') return result
    if ([null, undefined, ''].includes(result as null | undefined | '')) return ''
    if (Array.isArray(result) && result.every((item) => !item || typeof item !== 'object'))
      return result.filter((item) => ![null, undefined, ''].includes(item)).join(', ')
    return JSON.stringify(result)
  })

  return res
}

//* This function extracts from a string the variables that are inside {{}}
export function extractTemplateKeys(text: string): string[] {
  const keys = text.match(/\{\{([^}]+)\}\}/g)
  return keys?.map((key) => key.replace(/\{\{|\}\}/g, '')) || []
}
